import { ModelTableView } from '@/assets/js/ModelView'
import * as C from '../list'

const organisation = new ModelTableView([
	C.name,
	C.description,
	C.phone,
	C.email,
	C.webUrl,
	C.remarks,
	C.state
]);

organisation.visibleProperties([ "name", "description", "webUrl", "phone", "email" ]);
organisation.sortBy("name");

export default organisation;



// WEBPACK FOOTER //
// ./src/services/components/views/organisation.js